export default __webpack_public_path__ + "static/media/you-do-you-boo.ead3b513.gif";